import React from 'react';
import { Countdown } from './Countdown';
import { offer } from '../data/offer';
export function Urgency() {
  return <section className="w-full bg-night" data-id="element-337" data-mp="2bvmj3yrvslo9">
      <div className="max-w-3xl mx-auto px-5 py-14 sm:py-16 text-center" data-id="element-338" data-mp="2bubjmb5gy02y">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-shuttle" data-id="element-339" data-mp="1wyvn7zhf1s3e">
          Limited-time offer
        </p>
        <h2 className="mt-3 font-display font-bold text-white text-2xl tracking-tight sm:text-4xl" data-id="element-340" data-mp="220b6pn3y3qjo">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-341" data-mp="1syv4i2naauqj">
          <Countdown tone="dark" data-id="element-342" data-mp="1sz4pfbth2bpd" />
        </div>
        <p className="mt-5 text-sm text-white/70" data-id="element-343" data-mp="1e9ffar3eixcy">
          After that the price goes up by{' '}
          <span className="font-bold text-coral-soft" data-id="element-344" data-mp="1j7gxl9t06snd">${offer.priceRise}</span>{' '}
          and stays there.
        </p>
      </div>
    </section>;
}